import { on } from "@ngrx/store";
import { ContactState } from "../contact.state";
import { ContactsActions } from "./contacts.actions";
import { UserActions } from "../../../user/user.actions";
import { PagesStore } from "../../pages.state";

// ============================================================================
// HELPER
// ============================================================================

function withContact(state: PagesStore, updater: (contact: ContactState) => ContactState): PagesStore {
    return { ...state, contact: updater(state.contact) };
}

// ============================================================================
// CONTACTS LIST REDUCER (flattened structure)
// ============================================================================

const load = on(
    ContactsActions.load,
    (state: PagesStore) => withContact(state, contactState => ({
        ...contactState,
        loadingList: true,
    })),
);

// loadSuccess saves everything in one action
const loadSuccess = on(
    ContactsActions.loadSuccess,
    (state: PagesStore, { contacts, totalCount, params }) => withContact(state, contactState => ({
        ...contactState,
        contacts: contacts ?? [],
        loaded: true,
        pageNumber: params.pagination.pageIndex,
        pageSize: params.pagination.pageSize,
        totalCount: totalCount ?? 0,
        sortProperty: params.sorting.sortProperty,
        sortAscending: params.sorting.sortAscending,
        searchFilter: params.searchFilter,
        loadingList: false,
        error: null,
    })),
);

const loadFailure = on(
    ContactsActions.loadFailure,
    (state: PagesStore, { error }) => withContact(state, contactState => ({
        ...contactState,
        loadingList: false,
        error,
    })),
);

const invalidate = on(
    ContactsActions.invalidate,
    UserActions.changeCompanySuccess,
    (state: PagesStore) => withContact(state, contactState => ({
        ...contactState,
        loaded: false,
    })),
);

const setVisibleColumns = on(
    ContactsActions.setVisibleColumns,
    (state: PagesStore, { visibleColumns }) => withContact(state, contactState => ({
        ...contactState,
        visibleColumns,
    })),
);

export const contactsReducer = [load, loadSuccess, loadFailure, invalidate, setVisibleColumns];
